import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { PERMISSION_PERIOD_LOCK } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';
import PeriodLockSetting from '../../components/PeriodLock/PeriodLockSetting';

// Optional search params (deep-link / row-action filters); never fail validation.
const periodLockDefEditSearchSchema = z.object({
  customerId: z.coerce.number().optional().catch(undefined),
});

export const Route = createFileRoute('/_authenticated/period-lock/definition/edit/$id')({
  validateSearch: periodLockDefEditSearchSchema,
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_PERIOD_LOCK, ['update'], '/unauthorized', context);
    return {
      ...context,
      documentTitle: {
        main: 'periodLock.editSetting',
        suffix: 'menu.periodLock',
      },
    };
  },
  // Modal opened by the PeriodLockSetting list based on the URL.
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: RouteView,
});

function RouteView() {
  return <PeriodLockSetting />;
}
